<template>
    <div class="search-page">
        <div v-if="isLoaded" class="page">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Istoric de căutări</h1>
                    <p>Vezi ultimele tale 30 de căutări</p>
                    <div class="white-page">
                        <table class="table table-sm table-borderless table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Căutare</th>
                                    <th scope="col">Dată</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="search in searches" :key="search.id">
                                    <td>{{ search.query }}</td>
                                    <td>{{ (new Date(search.created_at)).toLocaleString() }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "@/utils/axios-instance";

    export default {
        name: 'SearchHistory',
        components: {},
        data() {
            return {
                searches: null,
                isLoaded: false,
                errorMessage: null,
            }
        },
        watch: {
            // call again the method if the route changes
            '$route': 'fetchData'
        },
        created: async function () {
            await this.fetchData();
        },
        methods: {
            async fetchData() {
                let loader = this.$loading.show({
                    container: this.$refs.offer,
                });

                try {
                    let response = await axios.get(`/search/saved-searches/`);
                    this.searches = response.data;
                    this.isLoaded = true;

                    loader.hide();
                } catch (e) {
                    this.errorMessage = "Eroare la încărcare";
                }
            }
        }
    }
</script>

<style scoped>
    .search-page {
        flex-grow: 1;
        display: flex;
    }

    .page {
        flex-grow: 1;
        position: relative;
    }

    .cover {
        width: 100%;
        height: 264px;
        position: relative;
        background: #024A8C;
    }

    .container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 60px;
        color: white;
        width: 100%;
    }

    .white-page {
        background: white;
        border-radius: 5px;
        color: black;
        padding: 15px;

        margin-top: 50px;
        margin-bottom: 20px;

        -webkit-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        -moz-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
    }

    .white-page h1, h2, h3, h4, h5, h6 {
        color: #6F6F6F;
    }

    h1 {
        font-size: 2rem;
    }

    h2 {
        font-size: 1.5rem;
    }

    h3 {
        font-size: 1.25rem;
    }

    th {
        color: #024A8C;
        font-weight: 600;
    }
</style>
